"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewProjectApiService = void 0;
var axios_1 = __importDefault(require("axios"));
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var lodash_1 = require("lodash");
var NewProjectApiService = (function () {
    function NewProjectApiService(apiBaseUrl) {
        var _this = this;
        this.apiBaseUrl = apiBaseUrl;
        this.fetchRelatedContactsContext = function (parentId, parentType, secret) { return __awaiter(_this, void 0, Promise, function () {
            var url, response, _a, projectContainsContactTokens, crmObjectAssociatedContactIds, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.apiBaseUrl, "/integration/hubspot/project/related-contacts?parentId=").concat(parentId, "&parentType=").concat(parentType, "&secret=").concat(secret);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.get(url, { withCredentials: true })];
                    case 2:
                        response = _b.sent();
                        _a = response.data, projectContainsContactTokens = _a.projectContainsContactTokens, crmObjectAssociatedContactIds = _a.crmObjectAssociatedContactIds;
                        return [2, {
                                data: {
                                    projectContainsContactTokens: projectContainsContactTokens,
                                    crmObjectAssociatedContactIds: crmObjectAssociatedContactIds,
                                },
                            }];
                    case 3:
                        e_1 = _b.sent();
                        return [2, {
                                err: e_1.message,
                            }];
                    case 4: return [2];
                }
            });
        }); };
        this.sendCreateQwilrRequest = function (hubspotFields, secret, projectName, selectedContactId) { return __awaiter(_this, void 0, Promise, function () {
            var url, fields, response, e_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.apiBaseUrl, "/integration/hubspot/qwilrs");
                        fields = __assign({ secret: secret, projectName: projectName }, hubspotFields);
                        if (!!selectedContactId) {
                            fields = (0, lodash_1.extend)(fields, {
                                parentAssociations: {
                                    relatedContactId: selectedContactId,
                                },
                            });
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post(url, fields, { withCredentials: true })];
                    case 2:
                        response = _b.sent();
                        return [2, {
                                data: response.data[0],
                            }];
                    case 3:
                        e_2 = _b.sent();
                        return [2, {
                                err: ((_a = e_2.data) === null || _a === void 0 ? void 0 : _a.message) ? e_2.data.message : e_2.message,
                            }];
                    case 4: return [2];
                }
            });
        }); };
        this.fetchContactsFromIdsList = function (contactIds) { return __awaiter(_this, void 0, Promise, function () {
            var url, response, contacts, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.apiBaseUrl, "/integration/hubspot/contacts?ids=").concat(contactIds.join(","));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.get(url, { withCredentials: true })];
                    case 2:
                        response = _a.sent();
                        contacts = response.data.contacts.map(function (contact) {
                            contact.selected = false;
                            return contact;
                        });
                        return [2, {
                                data: contacts,
                            }];
                    case 3:
                        e_3 = _a.sent();
                        return [2, {
                                err: (0, AxiosErrorParser_1.getErrorMessage)(e_3),
                            }];
                    case 4: return [2];
                }
            });
        }); };
        this.fetchTemplates = function (objectType) { return __awaiter(_this, void 0, Promise, function () {
            var url, response, templates, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.apiBaseUrl, "/crmtemplates?object=").concat(objectType, "&crm=hubspot");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.get(url, { withCredentials: true })];
                    case 2:
                        response = _a.sent();
                        templates = response.data.map(function (template) {
                            template.selected = false;
                            return template;
                        });
                        return [2, {
                                data: templates,
                            }];
                    case 3:
                        e_4 = _a.sent();
                        return [2, {
                                err: e_4.message,
                            }];
                    case 4: return [2];
                }
            });
        }); };
    }
    return NewProjectApiService;
}());
exports.NewProjectApiService = NewProjectApiService;
